import { Component } from '@angular/core';

/**
 * Home app
 */
@Component({
  selector: 'body',
  templateUrl: './app.component.html',
})
export class AppComponent {
  isStaging: boolean = process.env.STAGING === 'true'
}